module.exports = __webpack_public_path__ + "190c96c1babf55b7face3fd7ad10df2a.svg";